var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWirtualnaMataLogoCz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 477 105",
    style: {
      enableBackground: "new 0 0 477 105"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svg01{fill:#FFFFFF;}\n\t.svg02{fill:#00AEEF;}\n\t.svg03{fill:#ED1C24;}\n\t.svg04{fill:#231F20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31.1,
    y: 30.8,
    className: "svg01",
    width: 18.9,
    height: 19.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg01",
    d: "M74.5,49.9v-2.7c-8.7-1-15.6-7.8-16.8-16.4h-2.6v19.1H74.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg01",
    d: "M98.3,30.8h-2.5c-1.2,8.4-7.8,15.1-16.2,16.3v2.8h18.7V30.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.1,
    y: 6.9,
    className: "svg01",
    width: 18.9,
    height: 18.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg01",
    d: "M57.7,25.7C58.8,17,65.7,10,74.5,9V6.9H55.1v18.8C55.1,25.7,57.7,25.7,57.7,25.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.1,
    y: 30.8,
    className: "svg01",
    width: 18.9,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.1,
    y: 79.3,
    className: "svg01",
    width: 19.4,
    height: 18.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg01",
    d: "M47.6,79.3c-1.3,8.4-8,14.9-16.4,16.1v2.7H50V79.3H47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg01",
    d: "M7.1,74.2h2.4c1-8.8,7.9-15.8,16.6-17V55h-19V74.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.1,
    y: 6.9,
    className: "svg01",
    width: 18.9,
    height: 18.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg01",
    d: "M26,95.3c-8.4-1.1-15.1-7.7-16.4-16.1H7.1V98H26V95.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.6,
    y: 79.3,
    className: "svg01",
    width: 18.7,
    height: 18.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg01",
    d: "M95.9,25.7h2.4V6.9H79.6v2.2C88.1,10.3,94.8,17.2,95.9,25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg01",
    d: "M31.1,55v2.2c8.7,1.2,15.6,8.2,16.6,17H50V55H31.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.6,
    y: 55,
    className: "svg01",
    width: 18.7,
    height: 19.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.1,
    y: 55,
    className: "svg01",
    width: 19.4,
    height: 19.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "svg02",
    cx: 28.6,
    cy: 76.3,
    r: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg03",
    d: "M76.8,13.5c-8,0-14.6,6.5-14.6,14.6s6.5,14.6,14.6,14.6s14.6-6.5,14.6-14.6S84.8,13.5,76.8,13.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "svg03",
    points: "98.3,49.9 79.6,49.9 74.5,49.9 55.1,49.9 55.1,30.8 55.1,25.7 55.1,6.9 50,6.9 50,25.7 50,30.8  50,49.9 31.1,49.9 26,49.9 7.1,49.9 7.1,55 26,55 31.1,55 50,55 50,74.2 50,79.3 50,98.1 55.1,98.1 55.1,79.3 55.1,74.2 55.1,55  74.5,55 79.6,55 98.3,55  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M100.8,1.8H4.5C3.1,1.8,2,3,2,4.4v96.3c0,1.4,1.1,2.5,2.5,2.5h96.3c1.4,0,2.5-1.1,2.5-2.5V4.4 C103.4,3,102.2,1.8,100.8,1.8z M79.6,74.2V55h-5.1v19.2H55.1v5.1h19.4v18.8H55.1H50H31.1v-2.7c8.4-1.1,15.1-7.7,16.4-16.1H50v-5.1 h-2.3c-1-8.8-7.9-15.8-16.6-17V55H26v2.2c-8.7,1.2-15.6,8.2-16.6,17H7.1V55v-5.1V30.8H26v19.1h5.1V30.8H50v-5.1H31.1V6.9H50h5.1 h19.4V9c-8.8,1-15.7,8-16.8,16.7h-2.5v5.1h2.6c1.2,8.6,8.1,15.4,16.8,16.4v2.7h5.1v-2.8c8.4-1.2,15-7.9,16.2-16.3h2.5v19.1V55v19.2 H79.6z M98.3,79.3v18.8H79.6V79.3H98.3z M7.1,79.3h2.5c1.3,8.4,8,14.9,16.4,16.1v2.7H7.1V79.3z M14,76.3c0-8,6.5-14.6,14.6-14.6 s14.6,6.5,14.6,14.6s-6.5,14.6-14.6,14.6S14,84.3,14,76.3z M7.1,25.7V6.9H26v18.8C26,25.7,7.1,25.7,7.1,25.7z M98.3,6.9v18.8h-2.4 c-1.1-8.6-7.8-15.4-16.3-16.6V6.9H98.3z M91.3,28.1c0,8-6.5,14.6-14.6,14.6s-14.6-6.5-14.6-14.6s6.5-14.6,14.6-14.6 S91.3,20.1,91.3,28.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M166.5,49c-2.2,0-3.7-1.3-5.2-3.7l-7-11.2l-2.8,2.9v6.6c0,3.4-2,5.3-5.7,5.3c-3.6,0-5.7-2-5.7-5.5V17.5 c0-3.4,2.2-5.4,5.7-5.4c3.7,0,5.7,1.8,5.7,5.2v7.1l8.8-10.2c1.3-1.5,2.6-2.2,4.2-2.2c2.8,0,4.8,1.9,4.8,4.3c0,1.7-1.1,3.3-3.1,5.3 l-3.9,4.1L171,39c0.9,1.5,1.6,2.8,1.6,4.5C172.6,46.4,169.7,49,166.5,49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M192.6,49.3c-11.5,0-18.6-7.2-18.6-18.8s7.1-18.9,18.6-18.9c11.5,0,18.6,7.2,18.6,18.9S204.1,49.3,192.6,49.3z  M192.6,20.6c-4.8,0-7,3.1-7,9.9c0,6.7,2.2,9.8,7,9.8c4.9,0,7-3.1,7-9.8S197.5,20.6,192.6,20.6z M197.9,6.2l-2.6,3.2 c-0.6,0.7-1.6,0.9-3.2,0.9c-2.4,0-3.1-1-3.1-2c0-0.4,0.2-0.9,0.5-1.4l2.4-4.1c0.5-0.8,1.6-1.5,3.1-1.5c2.4,0,3.9,1.4,3.9,2.9 C198.8,4.9,198.5,5.6,197.9,6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M243.1,45.4c-4,2.9-8.9,3-15.4,3h-4.8c-5.1,0-6.9-1.6-6.9-6.6V19.2c0-5,1.8-6.6,6.9-6.6h7 c5.5,0,9.6,0.4,12.6,2.3c4.9,3,7.2,8,7.2,15.4C249.6,37.3,247.5,42.3,243.1,45.4z M230.7,21.6h-3.2v17.7h3.1c5.7,0,7.7-2.5,7.7-8.8 C238.2,24.3,235.9,21.6,230.7,21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M271.5,49.3c-11.5,0-18.6-7.2-18.6-18.8s7.1-18.9,18.6-18.9c11.5,0,18.6,7.2,18.6,18.9S283,49.3,271.5,49.3z  M271.5,20.6c-4.8,0-7,3.1-7,9.9c0,6.7,2.2,9.8,7,9.8c4.9,0,7-3.1,7-9.8S276.4,20.6,271.5,20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M323.1,19.3l-8.6,25.5c-0.9,2.6-2.9,4.1-5.2,4.1h-3.6c-2.4,0-4.3-1.5-5.2-4.1l-8.5-25.5 c-0.3-0.9-0.5-1.7-0.5-2.3c0-3,2.3-4.9,6.1-4.9c2.2,0,3.9,1.3,4.6,3.9l5.2,19.7l5.3-19.7c0.7-2.6,2.3-3.9,4.6-3.9 c3.7,0,6.1,2,6.1,4.9C323.5,17.5,323.4,18.4,323.1,19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M351.2,49c-2.4,0-4-1.1-4.9-3.2l-0.8-2.1h-11.5l-0.8,2.1c-0.8,2.1-2.5,3.2-4.8,3.2c-3.2,0-5.2-2-5.2-4.9 c0-0.9,0.1-1.7,0.3-2.2l8.7-24.5c1.3-3.7,2.7-5.3,5.8-5.3h3.3c3.3,0,4.5,1.6,5.8,5.3l8.8,24.5c0.2,0.5,0.3,1.3,0.3,2.3 C356.3,47,354.3,49,351.2,49z M339.8,23.7l-3.7,12.4h7.2L339.8,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M389,45.5c-3,2.5-7,3.8-11.8,3.8c-12,0-18.9-7.1-18.9-18.8c0-11.7,7-18.9,18.2-18.9c9.8,0,15.8,4.8,15.8,10.2 c0,2.9-2.2,5-5.1,5c-2.2,0-3.4-1-4.7-3c-1.5-2.2-2.9-3.3-5.7-3.3c-4.6,0-6.9,3.3-6.9,10c0,6.5,2.4,9.9,7,9.9c2.1,0,3.7-0.7,5-2.3 c0.5-0.7,1-1.8,2-2.7c0.8-0.8,2-1.2,3.3-1.2c3,0,5.2,2.2,5.2,5C392.4,41.3,391.2,43.6,389,45.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M403.3,48.8c-3.8,0-5.7-1.8-5.7-5.3V17.5c0-3.4,2.1-5.4,5.7-5.4c3.7,0,5.7,1.8,5.7,5.2v26.1 C409.1,46.8,406.9,48.8,403.3,48.8z M409.6,6.2l-2.6,3.2c-0.5,0.7-1.6,0.9-3.2,0.9c-2.3,0-3.1-1-3.1-2c0-0.4,0.2-0.9,0.5-1.4 l2.4-4.1c0.5-0.8,1.6-1.5,3.1-1.5c2.4,0,3.9,1.4,3.9,2.9C410.4,4.9,410.1,5.6,409.6,6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M157.8,86.3h-6.2v6.3c0,3.5-2,5.3-5.7,5.3c-3.6,0-5.8-2-5.8-5.5V68.1c0-5,1.8-6.6,6.9-6.6h7.8 c5.5,0,9.6,0.5,12.5,2.4c3.3,2.3,4.9,5.5,4.9,10.1C172.3,82.2,167.5,86.3,157.8,86.3z M155.4,70.2h-3.7v7.3h3.7c4.1,0,6-0.5,6-3.7 C161.4,70.6,159.4,70.2,155.4,70.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M193.7,98.2c-11.5,0-18.6-7.2-18.6-18.8c0-11.7,7.1-18.9,18.6-18.9c11.5,0,18.6,7.2,18.6,18.9 C212.3,91,205.2,98.2,193.7,98.2z M193.7,69.5c-4.8,0-7,3.1-7,9.9c0,6.7,2.2,9.8,7,9.8c4.9,0,7-3.1,7-9.8 C200.7,72.7,198.6,69.5,193.7,69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M244.2,94.3c-4,2.9-8.9,3-15.4,3h-4.8c-5.1,0-6.9-1.6-6.9-6.6V68.1c0-5,1.8-6.6,6.9-6.6h7 c5.5,0,9.6,0.4,12.6,2.3c4.9,3,7.2,8,7.2,15.4C250.8,86.2,248.6,91.2,244.2,94.3z M231.8,70.5h-3.2v17.7h3.1c5.7,0,7.7-2.5,7.7-8.8 C239.3,73.2,237.1,70.5,231.8,70.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M277.7,97.3h-16.3c-3.9,0-5.7-1.6-5.7-5.3V66.4c0-3.4,2.1-5.4,5.7-5.4c3.7,0,5.7,1.8,5.7,5.2V88h10.5 c3.3,0,5,1.6,5,4.8C282.6,95.7,280.9,97.3,277.7,97.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M302.8,98.2c-11.5,0-18.6-7.2-18.6-18.8c0-11.7,7.1-18.9,18.6-18.9c11.5,0,18.6,7.2,18.6,18.9 C321.4,91,314.3,98.2,302.8,98.2z M302.8,69.5c-4.8,0-7,3.1-7,9.9c0,6.7,2.2,9.8,7,9.8c4.9,0,7-3.1,7-9.8 C309.8,72.7,307.6,69.5,302.8,69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M350.5,97.3h-21.9c-4.1,0-6.1-1.6-6.1-4.7c0-2.2,1.2-3.6,2.8-5.5l14.1-16.4h-11.1c-3.3,0-5-1.6-5-4.6 c0-3.1,1.6-4.7,5-4.7h20.5c4,0,6.1,1.9,6.1,4.7c0,2.1-1,3.6-2.7,5.5L337.8,88h12.6c3.4,0,5,1.6,5,4.8 C355.5,95.7,353.8,97.3,350.5,97.3z M345.9,51.9l-2.8,5c-1,1.7-2.1,2.3-4,2.3c-2,0-3.1-0.5-3.9-2.3l-2.7-5c-0.2-0.4-0.2-0.7-0.2-1 c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.4,0.3,2,1l3.4,4.1l3.5-4.1c0.6-0.7,1-1,1.9-1c0.9,0,1.6,0.7,1.6,1.6 C346.2,51.3,346.1,51.6,345.9,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M385.5,97.9c-2.2,0-3.7-1.3-5.2-3.7l-7-11.2l-2.8,2.9v6.6c0,3.4-2,5.3-5.7,5.3c-3.6,0-5.7-2-5.7-5.5V66.4 c0-3.4,2.2-5.4,5.7-5.4c3.7,0,5.7,1.8,5.7,5.2v7.1l8.8-10.2c1.3-1.5,2.6-2.2,4.2-2.2c2.8,0,4.8,1.9,4.8,4.3c0,1.7-1.1,3.3-3.1,5.3 l-3.9,4.1l8.5,13.3c0.9,1.5,1.6,2.8,1.6,4.5C391.5,95.3,388.7,97.9,385.5,97.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M422.1,97.9c-2.4,0-4-1.1-4.9-3.2l-0.8-2.1H405l-0.8,2.1c-0.8,2.1-2.5,3.2-4.8,3.2c-3.2,0-5.2-2-5.2-4.9 c0-0.9,0.1-1.7,0.3-2.2l8.7-24.5c1.3-3.7,2.7-5.3,5.8-5.3h3.3c3.3,0,4.5,1.6,5.8,5.3l8.8,24.5c0.2,0.5,0.3,1.3,0.3,2.3 C427.3,95.9,425.3,97.9,422.1,97.9z M410.8,72.6L407.2,85h7.2L410.8,72.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWirtualnaMataLogoCz);
export default __webpack_public_path__ + "static/media/wirtualna_mata_logo_cz.5867bff5.svg";
export { ForwardRef as ReactComponent };